angular.module('leftPaneModule', []);
